import { ref } from "vue";
import $ls, { LocalStorageKey } from "@/utils/local-storage";
import { DRAWER_WIDTH } from "@/components/canvas/layouts/constants";

/**
 * Largeur du volet droit du canvas (drawer), redimensionnable par poignée et
 * persistée. Module partagé (mêmes refs partout) : le volet l'applique, la
 * popup des marqueurs photo s'y cale (elle se positionne à sa gauche).
 */

export const DRAWER_MIN_WIDTH = 260;
export const DRAWER_MAX_WIDTH = 640;

const clamp = (width: number): number =>
  Math.min(DRAWER_MAX_WIDTH, Math.max(DRAWER_MIN_WIDTH, Math.round(width)));

function initialWidth(): number {
  const stored = Number($ls.getItem(LocalStorageKey.CANVAS_DRAWER_WIDTH));
  return Number.isFinite(stored) && stored > 0 ? clamp(stored) : DRAWER_WIDTH;
}

export const drawerWidth = ref(initialWidth());

/** Un volet est ouvert (les éléments calés à sa gauche s'en écartent). */
export const isDrawerOpen = ref(false);

export function setDrawerWidth(width: number): void {
  drawerWidth.value = clamp(width);
  $ls.setItem(LocalStorageKey.CANVAS_DRAWER_WIDTH, String(drawerWidth.value));
}

/** Retour à la largeur par défaut (double-clic sur la poignée). */
export function resetDrawerWidth(): void {
  setDrawerWidth(DRAWER_WIDTH);
}
